export default __webpack_public_path__ + "static/media/banner_5b.947fa934.jpg";